<template>
  <div class="content main-container">
    <Tabs v-model="activeTab" :animated="false" @on-click="handleTabChange">
      <TabPane label="active状态查询" name="query">
        <ActiveQuery :userList="userList" ref="activeQuery"></ActiveQuery>
      </TabPane>
      <TabPane label="回溯记录" name="retrospect">
        <RetrospectRecord :userList="userList" ref="retrospectRecord"></RetrospectRecord>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import ActiveQuery from './components/ActiveQuery';
import RetrospectRecord from './components/RetrospectRecord';

export default {
  name: 'ActiveManage',
  components: {
    ActiveQuery,
    RetrospectRecord
  },
  data() {
    return {
      activeTab: 'query',
      userList: []
    };
  },
  mounted() {
    this.getUserList();
    console.log('[ActiveManage] 页面加载完成');
  },
  methods: {
    
    getUserList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: {
          selectSub: 1
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    /**
     * 标签页切换
     * @param {string} name - 标签名称
     */
    handleTabChange(name) {
      console.log('[ActiveManage] 切换标签', name);

      // 切换标签时可以触发对应组件的数据刷新
      this.$nextTick(() => {
        if (name === 'query' && this.$refs.activeQuery) {
          // 可以在这里调用组件的刷新方法
          // this.$refs.activeQuery.resetQuery();
        } else if (name === 'retrospect' && this.$refs.retrospectRecord) {
          // 可以在这里调用组件的刷新方法
          // this.$refs.retrospectRecord.resetQuery();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
